import { render, staticRenderFns } from "./AdminUsuariosComponent.vue?vue&type=template&id=2d806bec&scoped=true"
import script from "./AdminUsuariosComponent.vue?vue&type=script&lang=ts"
export * from "./AdminUsuariosComponent.vue?vue&type=script&lang=ts"
import style0 from "./AdminUsuariosComponent.vue?vue&type=style&index=0&id=2d806bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d806bec",
  null
  
)

export default component.exports